import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './alert.module'
import { auth } from './auth.module'
import { usersSubmission } from './user.module'
import { projectSubmission } from './projects.module'
import { labelledImagesSubmission } from './labels.module'
import { license } from './license.module'
import { BottomSheet } from './bottomSheet.module'
import { BottomSheetPms } from './bottomSheetPms.module'
import { staffReport } from './staff.report.module'
import { staffSubmission } from './staff.submission.module'
import { uploader } from './uploader.module'
import { zipUploader } from './zipUploader.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    alert,
    auth,
    staffReport,
    staffSubmission,
    projectSubmission,
    usersSubmission,
    labelledImagesSubmission,
    license,
    BottomSheet,
    BottomSheetPms,
    uploader,
    zipUploader
  }
})
